import { ChangeDetectionStrategy, Component, OnChanges, input, signal } from '@angular/core';

/**
 * Guest profile photo: a `.ft-image-div` whose background-image is the profile photo,
 * preloaded so a broken/missing photo falls back to the silhouette class. The div is
 * always rendered.
 */
@Component({
    selector: 'ft-guest-photo',
    templateUrl: './guest-photo.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuestPhotoComponent implements OnChanges {
    readonly src = input<string | null>();
    readonly silhouetteClass = input('');

    protected readonly resolvedUrl = signal<string | null>(null);

    ngOnChanges(): void {
        this.resolvedUrl.set(null);
        const src = this.src();
        if (!src) return;
        const img = new Image();
        img.onload = () => {
            this.resolvedUrl.set(img.src);
        };
        img.onerror = () => {
            this.resolvedUrl.set(null);
        };
        img.src = src;
    }
}
